/**
 * Which pair of elements makes which fused element, keyed by the two names sorted and joined with
 * a pipe. Build the key with `fkey` rather than by hand so the ordering always matches.
 */
export const FUSE: Record<string, string> = {
	"fire|water": "steam",
	"earth|fire": "glass",
	"air|fire": "wildfire",
	"bolt|fire": "plasma",
	"earth|water": "mud",
	"air|water": "whirl",
	"bolt|water": "surge",
	"air|earth": "dust",
	"bolt|earth": "magnet",
	"air|bolt": "storm",
	"fire|space": "nova",
	"space|water": "rift",
	"earth|space": "meteor",
	"air|space": "vacuum",
	"bolt|space": "pulsar",
	"fire|poison": "blight",
	"poison|water": "sludge",
	"earth|poison": "spores",
	"air|poison": "miasma",
	"bolt|poison": "necrosis",
	"poison|space": "entropy",
	"fire|life": "phoenix",
	"life|water": "spring",
	"earth|life": "orchard",
	"air|life": "zephyr",
	"bolt|life": "pulse",
	"life|space": "rebirth",
	"life|poison": "rot",
	"fire|iron": "forge",
	"iron|water": "quench",
	"earth|iron": "bastion",
	"air|iron": "shrapnel",
	"bolt|iron": "dynamo",
	"iron|space": "lodestone",
	"iron|poison": "rust",
	"iron|life": "bulwark",
	"echo|fire": "ashfall",
	"echo|water": "ripple",
	"earth|echo": "tremor",
	"air|echo": "howl",
	"bolt|echo": "thunder",
	"echo|space": "singularity",
	"echo|poison": "contagion",
	"echo|life": "harmony",
	"echo|iron": "bell",
	"fire|shadow": "emberveil",
	"shadow|water": "gloom",
	"earth|shadow": "cavern",
	"air|shadow": "shade",
	"bolt|shadow": "flicker",
	"shadow|space": "eclipse",
	"poison|shadow": "murk",
	"life|shadow": "haven",
	"iron|shadow": "bunker",
	"echo|shadow": "whisper",
	"shadow|shadow": "oblivion",
	"fire|light": "flare",
	"light|water": "shimmer",
	"earth|light": "beacon",
	"air|light": "dawn",
	"bolt|light": "flash",
	"light|space": "starfall",
	"light|poison": "blister",
	"life|light": "sanctuary",
	"iron|light": "lantern",
	"echo|light": "radiance",
	"light|shadow": "twilight",
	"frost|light": "glare",
	"light|light": "dayburst",
	"fire|frost": "meltwater",
	"frost|water": "glacier",
	"earth|frost": "permafrost",
	"air|frost": "blizzard",
	"bolt|frost": "hail",
	"frost|space": "absolute",
	"frost|poison": "rime",
	"frost|life": "hibernation",
	"frost|iron": "coldiron",
	"echo|frost": "chill",
	"frost|shadow": "whiteout",
	"frost|frost": "deepfreeze",
	"fire|fire": "firestorm",
	"water|water": "deluge",
	"earth|earth": "mountain",
	"air|air": "tempest",
	"bolt|bolt": "overload",
	"space|space": "abyss",
	"poison|poison": "plague",
	"life|life": "eden",
	"iron|iron": "adamant",
	"echo|echo": "cacophony",
};

export const fkey = (a: string, b: string): string => [a, b].sort().join("|");
